import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import AtosService from '../../../../services/ato-auth';
import Ato from './ato';


const ListarAtos = () => {


    const [atos, setAtos] = useState([]);
    const [arquivo, setArquivo] = useState(false);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [ato, setAto] = useState("");



    async function fetchAtosIn() {
        const response = await AtosService.listar({ limit: true });
        if (response.data.length >= 1) {
            setAtos(response.data)
            setVazio(false)
        } else {
            setAtos([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setAto(id);
        setEditar(true)
    }


    const handleArquivo = (id) => {
        setAto(id);
        setArquivo(true)
    }

    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar o ato?')) {
            await AtosService.deletar(id)
            alert("Ato deletado com sucesso!")
            fetchAtosIn();
        }
    }

    useEffect(() => {
        fetchAtosIn();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/atos/editar/${ato}`} />
        )
    } else if (arquivo) {
        return (
            <Navigate to={`/restrito/atos/arquivo/${ato}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setAtos={setAtos}
                        setVazio={setVazio}
                        fetchAtosIn={fetchAtosIn}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={4}>
                            {atos.map((ato, index) =>
                                <Ato
                                    fetchAtosIn={fetchAtosIn}
                                    ato={ato}
                                    key={index}
                                    editar={handleEditar}
                                    arquivo={handleArquivo}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarAtos;